import { useAppStore } from '../store/appStore'

/**
 * 官网 iframe 覆盖层。
 *
 * - phase === 'idle': 不挂载（节省一次 iframe 加载）
 * - phase === 'shrinking': 已挂载、停在 translateY(-100vh)，开始预加载 iframe 内容
 * - phase === 'curtain' | 'done': 滑下到 translateY(0)
 * - phase === 'returning': 滑回 translateY(-100vh)
 */
export function SiteFrame() {
  const phase = useAppStore((s) => s.phase)
  const view = useAppStore((s) => s.currentView)
  const back = useAppStore((s) => s.backToIntro)

  if (phase === 'idle' && view === 'intro') return null

  return (
    <div className={`site-frame phase-${phase} view-${view}`} aria-hidden={view !== 'site'}>
      <iframe src="/site/index.html" title="BNGU 实验室官网" />
      {view === 'site' && phase === 'done' && (
        <button
          className="site-frame__back"
          onClick={back}
          aria-label="返回引导页"
          title="返回引导页"
        >
          ← 引导页
        </button>
      )}
    </div>
  )
}
